import { useTranslation } from 'react-i18next';

import { Tag, Typography } from '@cfa/react-components';

interface LocationsFilterProps {
  locations: string[];
  onClick: (location: string) => void;
  onClose: (location: string) => void;
  selectedLocations?: string[];
}

const LocationsFilter: React.FC<LocationsFilterProps> = ({
  locations,
  onClick,
  onClose,
  selectedLocations = [],
}) => {
  const { t } = useTranslation();
  if (!locations.length) {
    return null;
  }
  return (
    <div className="mb-4 ml-0 flex flex-wrap items-center justify-start gap-2">
      <Typography variant="body2">{t('Search.filterBy')}</Typography>
      {locations.map((location, index) => (
        <Tag
          data-testid={`Chip-${index}`}
          key={index}
          label={location}
          onClick={
            selectedLocations.includes(location)
              ? undefined
              : () => onClick(location)
          }
          onClose={() => onClose(location)}
          variant={selectedLocations.includes(location) ? 'filled' : 'outlined'}
        />
      ))}
    </div>
  );
};

export default LocationsFilter;
